import { render } from "./LabelNode.vue?vue&type=template&id=52dd466f&scoped=true&ts=true"
import script from "./LabelNode.vue?vue&type=script&lang=ts"
export * from "./LabelNode.vue?vue&type=script&lang=ts"

import "./LabelNode.vue?vue&type=style&index=0&id=52dd466f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dd466f"]])

export default __exports__